import React from 'react';
import { Ruler, HelpCircle } from 'lucide-react';

/**
 * Компонент секции формы для ввода измерений талии и бедер
 */
const MeasurementsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  const unitLabel = formData.measurementSystem === 'metric' ? 'см' : 'дюйм';

  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Ruler className="w-5 h-5 mr-2 text-emerald-500" />
        Основные измерения
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Обхват талии */}
        <div>
          <label htmlFor="waist" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Обхват талии ({unitLabel})
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <input
              type="text"
              id="waist"
              name="waist"
              value={formData.waist}
              onChange={handleInputChange}
              className={`form-input pr-12 ${errors.waist ? 'input-error' : ''}`}
              placeholder={`Введите обхват талии в ${unitLabel}`}
              aria-describedby="waist-helper"
            />
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              <span className="text-gray-500 dark:text-gray-400 sm:text-sm" id="waist-unit">
                {unitLabel}
              </span>
            </div>
          </div>
          {errors.waist ? (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.waist}
            </p>
          ) : (
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" id="waist-helper">
              Измеряется в самой узкой части, обычно на уровне пупка
            </p>
          )}
        </div>

        {/* Обхват бедер */}
        <div>
          <label htmlFor="hip" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Обхват бедер ({unitLabel})
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <input
              type="text"
              id="hip"
              name="hip"
              value={formData.hip}
              onChange={handleInputChange}
              className={`form-input pr-12 ${errors.hip ? 'input-error' : ''}`}
              placeholder={`Введите обхват бедер в ${unitLabel}`}
              aria-describedby="hip-helper"
            />
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              <span className="text-gray-500 dark:text-gray-400 sm:text-sm" id="hip-unit">
                {unitLabel}
              </span>
            </div>
          </div>
          {errors.hip ? (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.hip}
            </p>
          ) : (
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" id="hip-helper">
              Измеряется по наиболее выступающим точкам ягодиц
            </p>
          )}
        </div>
      </div>

      {/* Инструкция по измерению */}
      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800">
        <div className="flex items-start">
          <HelpCircle className="text-blue-500 dark:text-blue-400 w-5 h-5 mr-3 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Как правильно измерять
            </h4>
            <ul className="text-xs text-blue-600 dark:text-blue-400 space-y-1 list-disc list-inside">
              <li>Используйте мягкую измерительную ленту</li>
              <li>Измеряйте прямо по коже или в легкой облегающей одежде</li>
              <li>Стойте прямо, расслабив мышцы живота, не втягивайте живот</li>
              <li>Талия: измеряйте в самом узком месте туловища, обычно на 2-3 см выше пупка</li>
              <li>Бедра: измеряйте по наиболее выступающим точкам ягодиц</li>
              <li>Лента должна прилегать к телу, но не сдавливать его</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeasurementsSection;